import { useColorMode } from '@tonic-ui/react';

export const styles = {
  support: {
    dark: {
      resourceText: 'white:emphasis',
      tagBackground: 'gray:70',
      tagText: 'gray:20',
      border: 'rgba(255, 255, 255, 0.12)',
      divider: 'gray:70',
      check: 'green:40',
      placeholderColor: 'white:tertiary',
      invalidBgColor: 'red:60',
      invalidBorderColor: 'red:50',
      errorText: 'red:60',
      borderColor: 'gray:60',
      focusBorderColor: 'blue:60',
    },
    light: {
      resourceText: 'black:primary',
      tagBackground: 'gray:20',
      tagText: 'gray:100',
      border: 'gray:20',
      divider: 'gray:20',
      check: 'green:50',
      placeholderColor: 'black:tertiary',
      invalidBgColor: 'red:60',
      invalidBorderColor: 'red:60',
      errorText: 'red:50',
      borderColor: 'gray:30',
      focusBorderColor: 'blue:60',
    },
  },
};

// Custom hook for setting different styles/colors for dark and light mode
type StylesConfig = typeof styles;

export const useCustomStyles = <K extends keyof StylesConfig>(
  pageName: K
): StylesConfig[K]['dark'] => {
  const [colorMode] = useColorMode();
  return styles[pageName][colorMode];
};
